var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"burger",attrs:{"data-voicetext":"открыть боковое меню"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('BurgerIcon',{staticClass:"burger__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }